<app-stepper [step]="step"></app-stepper>
<div>
	<div >
		<form  class="donation-form">
			<p class="step4-story" [innerHTML]="title | translate:transParam" ></p>

			<p>{{description | translate}} {{reasonAvailable | translate}}</p>
			<p>{{refusalReason}}</p>

			<div class="form-group">
				<button type="submit" onclick="window.location.href='/';"  mat-flat-button >{{'result.back_home' | translate}}</button>
			</div>
		</form>
	</div>

  <div class="mat-error" *ngIf="hasError">
    <span>{{'error.unknown' | translate}}</span>
  </div>

</div>
